
const SET_THEME = (state, payLoad) => {
  const { color, colorHTML } = payLoad
  state.theme.color = color
  state.theme.colorHTML = colorHTML
}

const SET_DEVICE = (state, payLoad) => {
  const { mobile, tablet } = payLoad
  state.device.isMobile = mobile
  state.device.isTablet = tablet
}

export default {
  SET_THEME,
  SET_DEVICE
}



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js